const PageLogo = props => <img alt="Logo" src="/static/FMS400.png" {...props} />

export default PageLogo
